<template>
  <div class="formprint">

  </div>  
</template>

<script>
// import DocumentService from '@/services/DocumentService'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
import langEn from './documentDescEn'
import langHr from './documentDescHR'
import commEn from '@/language/commonEN'
import commHr from '@/language/commonHR'
import {moneyFormat, round} from '@/snippets/allSnippets'
import documentLocalName from '@/snippets/documentLocalName'
import dayjs from 'dayjs'

export default {
  name: 'salesprint',
  data () {
    return {
      lang: {},
      langC: {},
      comp: {},
      docDefinition: {},
      content: [],
      striped: false,
      bordered: false,
      outlined: false,
      small: false,
      hover: false,
      dark: false,
      fixed: false,
      footClone: false,
      locCreatedAt: '',
      locUpdatedAt: '',
      order: 0,
      Total1: 0,
      Total2: 0,
      Total3: 0,
      Total4: 0,
      Total5: 0,
      Total6: 0,
      Total7: 0,
      Total8: 0,
      ana: {},
      documentName: '',
      page: 1,
      pageLine: 10,
    }
  },
  async mounted () {
    
  },
  methods: {
    async print () {
      this.page = 1
      if (this.$store.state.language === "EN") {
        this.lang = langEn
        this.langC = commEn
      }
      if (this.$store.state.language === "HR") {
        this.lang = langHr
        this.langC = commHr
      }
      this.comp = await this.$store.state.companyActiv
      this.ana = await this.$store.state.printObj
 
      this.initDocument()
      this.addHeaderNoLogo()
      this.addLine()
      this.addHeader()
      this.addLine()
      this.addItems(1)
      this.addLine()
      this.addTotal()
      this.addEmptyRow()
      this.addSignature()
      this.docDefinition.content = this.content
      await pdfMake.createPdf(this.docDefinition).open()

     
    },
    skipNewPage(lines) {
      this.pageLine += lines
      if (this.pageLine > 65) {
        this.pageLine = 5
        this.page += 1
        this.addLine()
        const docPart01 = {
        columns: [
            {
              width: '40%',
              fontSize: 7,
              bold: true,
              alignment: 'left',
              text: 'www.roboot.net',
              pageBreak: 'after'
            },
          ]
        }
        this.content.push(docPart01)
        this.addHeaderNoLogo()
        this.addLine()
        this.addHeader()
        this.addLine()
      }
    },
    localMoney (money) {
      return moneyFormat(money)
    },
    localName (name) {
      return documentLocalName(name)
    },
    formatDate (date) {
      if (!date) {
        return null
      }
      const [year, month, day] = date.split('-')
      return `${day}.${month}.${year}`
    },
    initDocument () {
      pdfMake.vfs = pdfFonts.pdfMake.vfs
      this.docDefinition = {}
      this.docDefinition.pageSize = 'A4'
      this.docDefinition.pageOrientation = 'portrait'
      this.docDefinition.pageMargins = [ 35, 20, 20, 20 ]
      this.content = []
    },
    formatPrice (value) {
      if (this.$store.state.language === 'EN') {
        let val = (value / 1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      }
      if (this.$store.state.language === 'HR') {
        let val = (value / 1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      }
    },
    addEmptyRow () {
      const docPart = {
            columns: [
              {
                width: '20%',
                text: [
                  { text: ' \n ', fontSize: 8 }
                ]
              },
              {
                width: '60%',
                text: [
                  { text: ' ', fontSize: 8 }
                ]
              }
            ]
          }
      this.content.push(docPart)
    },
    addLine () {
      const docPart = {
            canvas: [
              {
                type: 'line',
                x1: 0,
                y1: 0,
                x2: 520,
                y2: 0,
                lineWidth: 1
              }
            ]
          }
      this.content.push(docPart)
    },
    addHeaderNoLogo () {
      const docPart = {
            columns: [
              {      
                // % width
                width: '30%',
                text: [         
                  { text: this.comp.CompanyName + ' \n', fontSize: 10, bold: true },
                  { text: (this.comp.CompanyStreet ? this.comp.CompanyStreet : ' ') + ' ' + (this.comp.CompanyBuildingNameNumber ? this.comp.CompanyBuildingNameNumber : ' ') + ' \n', fontSize: 8 },
                  { text: (this.comp.CompanyPostcode ? this.comp.CompanyPostcode : ' ') + ' ' + (this.comp.CompanyCity ? this.comp.CompanyCity : ' ') + ' \n', fontSize: 8 },
                ]   
              },
              {
                // % width
                width: '45%',
                text: [
                  { text: this.ana.head1 + '\n', fontSize: 14, bold: true },
                  { text: (this.ana.head2 ?  this.ana.head2 : '') + '\n', fontSize: 12, bold: true},
                  { text: (this.ana.docFromDate ? 'Od:' + this.ana.docFromDate : '') + (this.ana.docToDate ? ', do:' + this.ana.docToDate : '') + '\n', fontSize: 10},
                ]   
              },
              {      
                // % width
                width: '20%',
                text: [         
                  { text: 'OIB:' + (this.comp.CompanyVATID ? this.comp.CompanyVATID : ' ') + ' \n', fontSize: 8},        
                  { text: 'Datum ispisa: ' + dayjs().format('DD.MM.YYYY, HH:mm'), fontSize: 7},
                  { text: ' Stranica: ' + parseInt(this.page) + '\n', fontSize:8}
                ]   
              }
             
            ],
            // optional space between columns
            columnGap: 10
          }
        this.content.push(docPart)
    },
    addHeaderTop () {
      const docPart = {
            columns: [
              {
                // auto-sized columns have their widths based on their content
                width: '30%',
                text: [
                  { text:' \n', fontSize: 10, bold: true },
                ]
              },
              {
                // % width
                width: '45%',
                text: [
                  { text:  this.ana.head1 ? this.ana.head1 + '\n' : '\n', fontSize:12, bold: true},
                  { text:  this.ana.head2 ? this.ana.head2 + '\n' : '\n', fontSize:10, bold: true},
                  { text:  this.ana.head4 ? this.ana.head4 + '\n' : '\n', fontSize:10, bold: true},
                  { text:  this.ana.head5 ? this.ana.head5 + '\n' : '\n', fontSize:10, bold: true}
                ]   
              },

            ],
            // optional space between columns
            columnGap: 10
          }
        this.content.push(docPart)
    },
    addHeader () {
        const docPart = {
        columns: [
            {
              width: '5%',
              fontSize: 8,
              alignment: 'left',
              text: 'Rb. \n'
            },
            
            {
              width: '6%',
              fontSize: 8,
              alignment: 'left',
              text:  'Dok.br \n'
            },
            {
              width: '10%',
              fontSize: 8,
              alignment: 'left',
              text:  'Dok.naziv\n'
            },
            {
              width: '9%',
              fontSize: 8,
              alignment: 'left',
              text:  'Datum\n'
            },
            {
              width: '10%',
              fontSize: 8,
              alignment: 'left',
              text: 'Partner \n'
            },
            {
              width: '9%',
              fontSize: 8,
              alignment: 'left',
              text:  'šifra \n'
            },
            {
              width: '16%',
              fontSize: 8,
              alignment: 'left',
              text: 'Naziv \n'
            },
            {
              width: '4%',
              fontSize: 8,
              alignment: 'center',
              text:  'Mjera \n'
            },
            {
              width: '8%',
              fontSize: 8,
              alignment: 'right',
              text: 'Kol \n'
            },
            {
              width: '10%',
              fontSize: 8,
              alignment: 'right',
              text:  'Izn.bez PDVa\n'
            },
            {
              width: '10%',
              fontSize: 8,
              alignment: 'right',
              text: 'Uk.Iznos\n'
            },
            ]
          }
        this.content.push(docPart)
    },

    addItems() {
      if (this.ana.items) {
        this.Total1 = 0
        this.Total2 = 0
        this.Total3 = 0
        this.Total4 = 0
        this.Total5 = 0
        this.Total6 = 0
         let id = 0
          this.ana.items.map(item => {
            const havePcs = this.ana.documentSide === 1 ? round(item.itemPcsPlus) : round(item.itemPcsMinus)
            if (havePcs != 0) {
              id += 1
              this.Total4 += this.ana.documentSide === 1 ? parseFloat(item.itemPcsPlus) : parseFloat(item.itemPcsMinus)
              this.Total5 += parseFloat(item.itemBaseAmountNoVAT)
              this.Total6 += parseFloat(item.itemFullTotal)
              const docPart = {
              columns: [
                    {
                      width: '5%',
                      fontSize: 8,
                      alignment: 'left',
                      text: id + '. \n'
                    },
                    
                    {
                      width: '6%',
                      fontSize: 8,
                      alignment: 'left',
                      text: item.documentId + '\n'
                    },
                    {
                      width: '10%',
                      fontSize: 8,
                      alignment: 'left',
                      text: this.localName(item.documentName) + '\n'
                    },
                    {
                      width: '8%',
                      fontSize: 8,
                      alignment: 'left',
                      text: this.formatDate(item.documentDate) + '\n'
                    },
                    {
                      width: '10%',
                      fontSize: 7,
                      alignment: 'left',
                      text: item.partnerNameDatabase.substr(0,12) + '\n'
                    },
                    {
                      width: '9%',
                      fontSize: 8,
                      alignment: 'left',
                      text: item.itemID + '\n'
                    },
                    {
                      width: '16%',
                      fontSize: 7,
                      alignment: 'left',
                      text: item.itemName.substr(0,16) + '\n'
                    },
                    {
                      width: '4%',
                      fontSize: 8,
                      alignment: 'center',
                      text: item.itemUnit + '\n'
                    },
                    {
                      width: '8%',
                      fontSize: 8,
                      alignment: 'right',
                      text: (this.ana.documentSide === 1 ? this.localMoney(item.itemPcsPlus) : this.localMoney(item.itemPcsMinus)) + '\n'
                    },
                    {
                      width: '10%',
                      fontSize: 8,
                      alignment: 'right',
                      text: this.localMoney(item.itemBaseAmountNoVAT) + '\n'
                    },
                    {
                      width: '10%',
                      fontSize: 8,
                      alignment: 'right',
                      text: this.localMoney(item.itemFullTotal) + '\n'
                    },

                  ]
                }
              this.content.push(docPart)
              this.skipNewPage(1)
            }
          })
      }
    },

    addTotal() {

          const docPart = {
          columns: [
              {
                width: '66%',
                fontSize: 8,
                alignment: 'left',
                text:  '\n'
              },

              {
                width: '10%',
                fontSize: 8,
                alignment: 'right',
                text: this.localMoney(this.Total4) + '\n'
              },
              {
                width: '10%',
                fontSize: 8,
                alignment: 'right',
                text: this.localMoney(this.Total5) + '\n'
              },
              {
                width: '10%',
                fontSize: 8,
                alignment: 'right',
                text: this.localMoney(this.Total6) + '\n'
              },
            ]
          }
          this.content.push(docPart)
      
    },

    addSignature () {
      const docPart = {
        columns: [
              {
                width: '5%',
                text: ' '
              },
              {
                width: '35%',
                text: [
                  { text: ' \n', fontSize: 8, alignment: 'center' }
                ]
              },
              {
                width: '5%',
                text: ' '
              },
              {
                width: '35%',
                text: [
                  { text:  '____________________ \n', fontSize: 8, alignment: 'center' }
                ]
              }
            ]
          }
      this.content.push(docPart)
    }

  },
  computed: {
  },
  watch: {
  },
  components: {
  }

}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.slide-fade-enter-active {
  transition: all 1.3s ease;
}
.slide-fade-leave-active {
  transition: all 1.8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for <2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>